import { setPopupVisibility } from 'store/actions/popup'
import get from 'lodash/get'

const popupReducer = (
  state = {
    errorPopup: '',
  },
  action
) => {
  const popupType = get(action, 'payload.type')

  if (action.type.endsWith('_FAIL')) {
    return {
      ...state,
      errorPopup: {
        isActive: true,
        data: get(action, 'error.response.data.error_code'),
      },
    }
  }

  switch (action.type) {
    case setPopupVisibility.show:
      return {
        ...state,
        [popupType]: {
          isActive: true,
          data: action.payload.data,
        },
      }
    case setPopupVisibility.hide:
      return {
        ...state,
        [popupType]: {
          isActive: false,
          data: undefined,
        },
      }
    default:
      return state
  }
}

export default popupReducer
